import Header from './HeaderContainer'

export default Header



// WEBPACK FOOTER //
// ./src/components/Header/index.js